export default "/images/92daa2494150048df15199e165ff0747.avif";